import React from "react";
import { getValueByPath } from "../Meta/metaUtils";

export default function MultiProgressStatCard({
  dataContext = {},
  theme = {},
}) {
  const props = dataContext?.props || {};

  const totalConfig = props.total || {
    label: props.totalLabel,
    path: props.totalPath,
  };

  const items = Array.isArray(props.items) ? props.items : [];

  const totalValue =
    Number(getValueByPath(dataContext, totalConfig?.path)) || 0;

  const trackColor = theme.trackColor || "#F1F5F9";
  const barHeight = theme?.bar?.height ?? 16;
  const barRadius = theme?.bar?.radius ?? 8;

  const labelClass =
    theme.labelClass || "text-sm font-medium text-[#989898]";
  const valueClass =
    theme.valueClass || "text-sm font-medium text-[#1A1A1A]";

  const tooltipTheme = theme.tooltip || {};

  return (
    <div className="flex flex-col gap-3">
      {/* Total */}
      <div className="flex items-baseline gap-2">
        <span className="text-xl font-medium text-[#1A1A1A]">
          {totalValue}
        </span>
        {totalConfig?.label && (
          <span className="text-sm text-[#1A1A1A]">
            {totalConfig.label}
          </span>
        )}
      </div>

      {/* Items */}
      <div className="flex flex-col gap-3">
        {items.map((item, idx) => {
          const valuePath =
            item?.value?.path || item?.path;

          const val =
            Number(getValueByPath(dataContext, valuePath)) || 0;

          const pct =
            totalValue > 0
              ? Math.min(100, (val / totalValue) * 100)
              : 0;

          return (
            <div key={idx} className="flex flex-col gap-1">
              {/* Label */}
              <div className={labelClass}>
                {item.label} –{" "}
                <span className={valueClass}>{val}</span>
              </div>

              {/* Track */}
              <div
                className="has-tooltip"
                style={{
                  height: barHeight,
                  borderRadius: barRadius,
                  backgroundColor: trackColor,
                  position: "relative",
                }}
              >
                {/* Bar */}
                <div
                  style={{
                    height: barHeight,
                    width: `${pct}%`,
                    borderRadius: barRadius,
                    backgroundColor: item.color,
                  }}
                />

                {/* Tooltip */}
                <div
                  className="tooltip"
                  style={{
                    backgroundColor:
                      tooltipTheme.backgroundColor ?? "#ffffff",
                    color: tooltipTheme.color ?? "#1A1A1A",
                    padding: tooltipTheme.padding ?? "8px 10px",
                    borderRadius:
                      tooltipTheme.borderRadius ?? "10px",
                    fontSize: tooltipTheme.fontSize ?? "12px",
                    top: "100%",
                    left: "50%",
                    transform: "translateX(-50%)",
                    marginTop: tooltipTheme.offset ?? 8,
                    whiteSpace: "nowrap",
                    pointerEvents: "none",
                  }}
                >
                  {val}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}